import React, { Component } from 'react';
import { connect } from 'react-redux';
import WorkBar from './workBar.jsx';
import WorkBarExpanded from './workBarExpanded.jsx';
import UnifiedMessaging from './unifiedMessaging.jsx';
import MessageBar from './messageBar.jsx';
import UnifiedInboxContainer from './unifiedInboxContainer';
import CallSpace from './callSpace.jsx';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import { USER_STATE, WORKBAR_ACTIONS, WINDOW_AT_500, DRAGGABLE_WINDOWS_ACTIONS, ALERTS_SHOWED, ALERTS_SHOWED_CODE, STATES_TO_SHOW_CTC } from '../../constants.js';
import ValidatingTelephonyLocked from './floatingWindows/validatingTelephony.jsx';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { moveBlockingPanel } from '../../redux/actions/A_blocking_panel';
import { consultingApp, noConsultingApp } from '../../redux/actions/A_reducer_consulting';
import AgentState from './agentState.jsx';
import { DRAGGABLE_WINDOWS, BLOCKING_ALERTS, INTEGRATION } from '../../constants';
import TimerCountDown from './Others/TimerCountDown';
import { Singleton } from '../../js/Singleton';
import SingletonWebSocket from '../../js/Singletons/SingletonWebSocket.js';
import OngoingCallIvrModal from './floatingWindows/OngoingCallIvrModal';
import { Logger } from '../../js/helpers/Logger';
import { manualCall, actionPreviewRecord } from '../../redux/actions/A_messages_to_SM';
import AlertModalActions from '../../redux/actions/A_Alert_Modal';
import { logout, sendMessageAgentReady } from '../../redux/actions/A_user_actions';
import CallWindowPreview from './CallComponents/CallWindowPreview.jsx';
import CallOutContainer from '../Animations/CallOutContainer';
import { setIsRunningClock, saveInitialTime, removeRecord} from '../../redux/actions/A_preview.js';
import { getCurrentTimeInSec } from '../../js/helpers/Utils/formats.js';
import { setShowPswResetAlert } from '../../redux/reducers/reducer_psw_reset.js';

//FLOATING WINDOWS
import BlockingPanel from './Others/BlockingPanel';
import AlertsContainerMessage from '../Alerts/AlertsContainerMessage.jsx';

//Connection Alert
import { Button } from 'global-components-library';
import warningAlert from '../../Images/Others/icon-warning.svg';
import ChangeTypeCampaign from './CallComponents/ChangeTypeCampaign/ChangeTypeCampaign.jsx';
import { setAgentList } from '../../redux/actions/A_preview_transfer.js';
class workSpace extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.state = {
      isLogged: false,
      typeBar: WORKBAR_ACTIONS.NONE,
      agentState500: true,
      draggableComponentList: [],
      alert: this.props.alert,
      actionAlert: '',
      closeWindow: '',
      newAlertCode: 0,
      newAlertMessage: null,
      hasUnifiedMessage: false,
      showCallWindowPreview: false,
      showAlertPasswordExpired: this.sharedData.getParameters().PswResetRequired,
      propsDraggables: {
        [DRAGGABLE_WINDOWS.MANUAL_CALL]: null,
        [DRAGGABLE_WINDOWS.TRANSFER_CALL]: null,
        [DRAGGABLE_WINDOWS.DTMF_TONES]: null,
        [DRAGGABLE_WINDOWS.CALL_RECORD]: null,
        [DRAGGABLE_WINDOWS.MARK_CALL]: null,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED]: null,
        [DRAGGABLE_WINDOWS.SUPERVISOR_CHAT]: null,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE]: null,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]: null,
        [DRAGGABLE_WINDOWS.ONGOING_CALL_IVR]: 200
      },
      zIndexDraggableWindows: {
        [DRAGGABLE_WINDOWS.MANUAL_CALL]: 200,
        [DRAGGABLE_WINDOWS.TRANSFER_CALL]: 200,
        [DRAGGABLE_WINDOWS.DTMF_TONES]: 200,
        [DRAGGABLE_WINDOWS.CALL_RECORD]: 200,
        [DRAGGABLE_WINDOWS.MARK_CALL]: 200,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED]: 200,
        [DRAGGABLE_WINDOWS.SUPERVISOR_CHAT]: 200,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE]: 200,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]: 200,
        [DRAGGABLE_WINDOWS.ONGOING_CALL_IVR]: 200
      },
      alertConnection: false,
      time: null,
    };
    this.userState = this.props.userState.currentState;
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.language = new Singleton();
    this.shortcut = [];
    this.alertStatregies = {
      [ALERTS_SHOWED_CODE.REPROGRAM_CALL_DIALOG]: () => this.setState({ actionAlert: ALERTS_SHOWED.INSERT_CALL_ALERT }),
      [ALERTS_SHOWED_CODE.REPROGRAM_CALL_NA]: () => this.setState({ actionAlert: ALERTS_SHOWED.INSERT_CALL_ALERT }),
      [ALERTS_SHOWED_CODE.REPROGRAM_NA_STATE]: () => this.setState({ actionAlert: ALERTS_SHOWED.INSERT_NO_AVAILABLE_ALERT }),
      [ALERTS_SHOWED_CODE.VOLUMEN_DISABLED]: () => this.setState({ actionAlert: ALERTS_SHOWED.INSERT_VOLUME_ALERT }),
      [ALERTS_SHOWED_CODE.READY_PREVIEW_MODE]: () => this.setState({ actionAlert: ALERTS_SHOWED.INSERT_PREVIEW_MODE_ALERT })
    };

    this.removeAlertStrategies = {
      [ALERTS_SHOWED_CODE.REPROGRAM_CALL_DIALOG]: () => this.cancelManualCallReprogramed(),
      [ALERTS_SHOWED_CODE.REPROGRAM_CALL_NA]: () => this.cancelManualCallReprogramed()
    };
    this.tmpStramLevel = 0;
    this.messageConnection = '';
    this.suspendMonitoring=false;
    this.timerActive=false;
    //Si no encuentra los parametros en el manifest.json asigna valores por default
    this.networkMonitoring = this.props.networkMonitoring ? this.props.networkMonitoring: {
      "active": false,
      "autoHide": 3000,
      "suspendMonitoring": 7000,
      "SndSuspendMonitoring": 10000
    };
  }
  componentDidMount() {
    this.setState({ hasUnifiedMessage: this.sharedData.hasUnifiedMessage });
    window.addEventListener('beforeunload', () => {
      this.props.logout();
    });
  }
  componentWillReceiveProps(nextProps) {
    let prop = this.state.propsDraggables;
    this.manageDragWindows(nextProps.dragWindowController);
    this.setState({
      agentState500: nextProps.windowVisible500.windowVisible === WINDOW_AT_500.NONE,
      newAlertMessage: nextProps.newAlertMessage,
      keyPressed: ''
    });
    this.userState = nextProps.userState.currentState;
    if (this.alertStatregies[nextProps.newAlertCode]) {
      this.alertStatregies[nextProps.newAlertCode]();
    }
    if (nextProps.alert) {
      if (BLOCKING_ALERTS[nextProps.alert.code]) {
        this.setState({ alert: nextProps.alert });
        this.props.moveBlockingPanel(350);
      } else {
        prop[DRAGGABLE_WINDOWS[nextProps.alert.module]] = { alertCode: nextProps.alert.code, message: nextProps.alert.message };
        this.setState({ propsDraggables: prop });
        if (this.alertStatregies[nextProps.alert.code]) {
          this.alertStatregies[nextProps.alert.code]();
        }
      }
    } else {
      prop[DRAGGABLE_WINDOWS.MANUAL_CALL] = null;
      prop[DRAGGABLE_WINDOWS.TRANSFER_CALL] = null;
      this.setState({ propsDraggables: prop });
    }
    if (nextProps.messagesIntegrations !== this.props.messagesIntegrations) {
      if (nextProps.messagesIntegrations.dataMessageIntegration && nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.GET_TRANSFER_DATA) {
        if (this.sharedData.isInCallState(this.userState)) {
          let objectResponseTransfer = this.apiCont.getObjectResponse();
          let userId = this.sharedData.getParameters().UserID;
          let acdId = this.props.dataCall.CallType === 1 ? this.props.dataCall.Id : 0; //filtro para el caso si es una llamda de entrada no puede transferir al mismo acd
          this.apiCont.transferCall(userId, acdId, objectResponseTransfer);
          objectResponseTransfer.onError = function (messageError) {
            Logger.Error('[WorkSpace][TransferCall] Error consulting DataBase ', messageError);
          };
          objectResponseTransfer.onSuccess = function (objResponse) {
            Logger.Trace("[WorkSpace][TransferCall] Receiving transfer options ", objResponse.Response);
            const data = [objResponse.AcdList, objResponse.TelefonosList, objResponse.AgentesList,];
            let message = { client: "galatea", data: data, action: "TransferOption", subaction:"getTransferOptions"};
            SingletonWebSocket.send(message);
          };
        }
      }
    }
  }
  componentDidUpdate() {
    if (this.state.actionAlert !== '') {
      this.setState({ actionAlert: '' }); 
    }
  }
  manageDragWindows(dragWindowComponent) {
    var arrayDrags = this.state.draggableComponentList;
    if (dragWindowComponent.actionType === DRAGGABLE_WINDOWS_ACTIONS.INSERT_WINDOW) {
      let arrayComponent = arrayDrags.filter(e => e.idComponent === dragWindowComponent.dragComponent.idComponent);
      if (arrayComponent.length === 0) {
        arrayDrags.push(dragWindowComponent.dragComponent);
      } else {
        if (dragWindowComponent.closeIfOpen) {
          arrayDrags = arrayDrags.filter(e => e.idComponent !== dragWindowComponent.dragComponent.idComponent);
        }
      }
      this.setState({
        draggableComponentList: arrayDrags,
        closeWindow: ''
      });

      this.sendToTop(dragWindowComponent.dragComponent.idComponent);
    }
    if (dragWindowComponent.actionType === DRAGGABLE_WINDOWS_ACTIONS.REMOVE_WINDOW) {
      if (typeof dragWindowComponent.idDragComponents !== 'undefined' && dragWindowComponent.idDragComponents.length > 0 && dragWindowComponent.idDragComponents !== 'null') {
        dragWindowComponent.idDragComponents.forEach(function (entry) {
          arrayDrags = arrayDrags.filter(e => e.idComponent !== entry);
        });
      }
      this.setState({
        draggableComponentList: arrayDrags,
        closeWindow: dragWindowComponent.idDragComponents[0]
      });
    }
  }
  classNameAgent500() {
    var str = 'agentStateDraggable showAt500';
    if (this.state.agentState500) {
      str += ' showAgentState500';
    } else {
      str += ' hideAgentState500';
    }
    return str;
  }
  onYes() {
    this.props.moveBlockingPanel(-1);
    if (this.alertStatregies[this.state.alert.code]) {
      this.alertStatregies[this.state.alert.code]();
    }
    this.setState({ alert: null });
  }
  onNo() {
    this.props.moveBlockingPanel(-1);
    this.setState({ alert: null });
    if (this.removeAlertStrategies[this.state.alert.code]) {
      this.removeAlertStrategies[this.state.alert.code]();
    }
  }
  cancelManualCallReprogramed() {
    Logger.Trace('[WorkSpace][cancelManualCallReprogramed] Cancel manual call reprogramed');
    var data = {
      CamId: 0,
      CallKey: '',
      Phone: '',
      Data: '',
      ExistsCallout: 0,
      CallMode: 0
    };
    this.props.manualCall(data);
  }
  componentWillUnmount() {
    this.sharedData.setLogged(false);
    Logger.Debug('[WorkSpace][componentWillUnmount] setLogged False');
  }
  alertVolumeWebRTC() {
    this.alertStatregies[ALERTS_SHOWED_CODE.VOLUMEN_DISABLED]();
  }
  getTagWaiting() {
    if(this.userState === USER_STATE.INACTIVE)
      return this.language.getText('GUIAlertMessageinactiveMode');
    else if(this.userState === USER_STATE.READY_PREVIEW)
      return this.language.getText('CallControlGUICallIOStatusgettingRegisters');
    else
      return this.language.getText('CallControlGUICallIOStatusgettingCall');
  }
  renderCallSpace() {
    const showCallWindowPreview = ((this.userState === USER_STATE.AGENT_PREVIEW || this.userState === USER_STATE.CALL_OUT) && this.props.preview.isSetPreviewRecord);
    const showCallWindowSimultaneousPreview = this.props.preview.simultaneosRecs && this.props.preview.isSetPreviewRecord  && (this.userState !== USER_STATE.READY_PREVIEW && this.userState && USER_STATE.AGENT_READY && this.userState !== USER_STATE.INACTIVE);
    if (this.sharedData.isInCallState(this.userState) && (this.props.userState.prevState !== USER_STATE.DIALOG_EMAIL && this.props.userState.prevState !== USER_STATE.DIALOG_WHATSAPP && this.props.userState.prevState !== USER_STATE.CHATTING) && !this.props.preview.simultaneosRecs) {
      return (
        <CallSpace
          onCloseWindow={this.state.closeWindow}
          currentState={this.userState}
          dataCall={this.props.dataCall}
          extraDataCall={this.props.extraDataCall}
          alertVolume={e => this.alertVolumeWebRTC()}
          actionPrevRecord={this.actionPrevRecord}
        />
      );
    }
    if(showCallWindowPreview || showCallWindowSimultaneousPreview) {
      return(
      <CallWindowPreview 
        fillAlertPreviewModal={this.fillAlertPreviewModal}
        userState={this.userState}
        dataCall={this.props.dataCall}
      />
      
      );
      }

    if (this.userState === USER_STATE.XFER) {
      return (
        <div className='XferContainer'>
          <div className='XferTimer'>
            <p className='XferPhrase'>{this.language.getText('CallControlGUICallIOStatusmanualCall')}</p>
            <TimerCountDown showingTimer={true} timeToRate={this.sharedData.getXferTime() + 1} lineWidth={9} colorDown={'#007FFF'} colorUp={'#033D76'} size={100} fontsize={'two'} />
          </div>
        </div>
      );
    }

    if (this.props.showUnifiedMessages && this.sharedData.generalPermissions[220] === '1') {
      return <UnifiedInboxContainer lang={this.sharedData.generalPermissions[27]} userId={this.sharedData.user.User_id} />;
    }

    
    if( this.props.allowChangeDialing && this.sharedData.getDataPreviewPro().dialingMode && STATES_TO_SHOW_CTC.includes(this.userState)) {
      return (
        <div className={`waitingCallText ${this.props.allowChangeDialing ? 'changeCampaign' : '' }`}>
            <div className='container__changeCampaign'>
              <p className='changeCampaign__p'>{this.language.getText('GUIPreviewselectCampaign')}</p>
              <ChangeTypeCampaign /> 
            </div>    
            <p className='waitingCallTextInfo'>{this.getTagWaiting()}</p>
        </div>
      )
    }

    return (
      <div className='waitingCallText'>
         <p className='waitingCallTextInfo'>{this.getTagWaiting()}</p>
      </div>
    );
  }
  sendToTop(componentToTop) {
    if (this.state.zIndexDraggableWindows[componentToTop] !== 300) {
      let initialValue = {
        [DRAGGABLE_WINDOWS.MANUAL_CALL]: 200,
        [DRAGGABLE_WINDOWS.TRANSFER_CALL]: 200,
        [DRAGGABLE_WINDOWS.DTMF_TONES]: 200,
        [DRAGGABLE_WINDOWS.CALL_RECORD]: 200,
        [DRAGGABLE_WINDOWS.MARK_CALL]: 200,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED]: 200,
        [DRAGGABLE_WINDOWS.SUPERVISOR_CHAT]: 200,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE]: 200,
        [DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]: 200,
        [DRAGGABLE_WINDOWS.ONGOING_CALL_IVR]: 200
      };

      initialValue[componentToTop] = 300;
      this.setState({ zIndexDraggableWindows: initialValue });
    }
  }
  setIsLogged = isLogged => {
    this.setState({ isLogged: isLogged });
  };
  isPressedUp = event => {
    if (event.ctrlKey && event.altKey) {
      this.setState({ keyPressed: event.key.toUpperCase() });
    }
  };
  onStreamAlert(streamLevel) {
    if (this.networkMonitoring.active && !this.suspendMonitoring && !this.timerActive) {
      if (this.tmpStramLevel !== streamLevel) {
        this.tmpStramLevel = streamLevel;
      }
      if (this.tmpStramLevel > 1 && !this.state.alertConnection) {
        this.autoHide(this.networkMonitoring.autoHide,this.networkMonitoring.suspendMonitoring);
      }
      this.messageAlert(streamLevel);
    }
  }

  autoHide(autoHide,suspending){
    this.setState({ alertConnection: true });
    this.timerActive=true;
    setTimeout(() => {
      this.setState({ alertConnection: false });
      this.suspendMonitoring=true;
      setTimeout(() => {
        this.suspendMonitoring=false;
        this.timerActive=false;
        if (this.tmpStramLevel === this.props.stramLevel) {
          this.autoHide(this.networkMonitoring.autoHide,this.networkMonitoring.SndSuspendMonitoring);
        }
      }, suspending);
    }, autoHide);
  }

  getMessageByLangId(langId){
		let message = "";

    const messages = {
      es: "La llamada se realizará al término del estado de diálogo.",
      en: "The call will be dialed upon the end of the engaged status.",
      pt: "A chamada será discada após o fim do status ‘em diálogo’."
    }

    switch(langId){
      case '0':
        message = messages.es;
        break;
      case '1':
        message = messages.en;
        break;
      case '2':
        message = messages.pt;
        break;
    }

    return message;
  }

  getMessageManualCallAfterWhatsApp(){
		let message = "";

		let {userState} = this.props;
		if(userState && this.state.alert.code && this.state.alert.code === '1093'){
      if(userState.currentState && (userState.currentState === USER_STATE.DIALOG_WHATSAPP || userState.currentState === USER_STATE.DIALOG_EMAIL)){

        if(this.language.getLanguage() === '-1'){
          message = this.getMessageByLangId(this.sharedData.generalPermissions[27]);
        }else{
          message = this.getMessageByLangId(this.language.getLanguage());
        }
      }
		}
		return message;
	}

  fillAlertModal() {
    let message = this.getMessageManualCallAfterWhatsApp();
    this.props.showAlertModal({
      type: "ModalAlert",
      title: this.state.alert.title,
      message: message ? message : this.language.getText('alert-' + this.state.alert.code),
      button: this.state.alert.btnYes,
      secondButton: this.state.alert.btnNo,
      secondButtonFtn: () => { if (this.state.alert.btnNo) { this.onNo(); } },
      buttonFun: () => { this.onYes() }
    });
  }
  
	closeAlert() {
		this.setState({ alertConnection: false });
	}	
  

  messageAlert(streamLevel) {
    if (streamLevel > 1) {
      this.state.time = new Date();
      let date = this.state.time.toTimeString();
      switch (streamLevel) {
        case 3:
          this.messageConnection = this.language.getText('GUIConnectivitybadMessage') + ' ' + this.language.getText('GUIConnectivityTime') + ' ' + date.substring(0, date.lastIndexOf('('));
          break;
        case 2: 
          this.messageConnection = this.language.getText('GUIConnectivityunstableMessage') + ' ' + this.language.getText('GUIConnectivityTime') + ' ' + date.substring(0, date.lastIndexOf('('));
          break;
        default:
          break;
      }
    }
  }
  actionPrevRecord = (opc) => {
    this.props.actionPreviewRecord(opc);
  }
  userHangedout() {
    this.userHangout = true;
    this.props.saveInitialTime();
    this.props.setIsRunningClock(true);
  }

  getMsgAlert = () =>{
    let objMsg={
      id: 'alert',
      icon: 'call-out',
      msg: this.state.alertMessage.Message,
    };
    return objMsg;
  }
  fillAlertPreviewModal= (record = {}) =>{
    this.props.showAlertModal({
      type: "ModalAlert",
      title: this.language.getText('GUIAlertMessagedeletePreviewRecord'),
      message: this.language.getText('GUIAlertMessagemsgDeletePreviewRecord'),
      button: this.language.getText('GUIPreviewdelete'),
      secondButton: this.language.getText('GUIAlertMessagecancel'),
      buttonFun: () =>  this.setObjTimePreview()
    });
  }
  fillAlertPasswordExpiredModal=() =>{
    this.props.showAlertModal({
      type: "ModalAlert",
      title: this.language.getText('GUIErrorMessagetitle'),
      message: this.language.getText('GUIPasswordResetpswErrorBody'),
      button: this.language.getText('GUIPasswordResetchangePsw'),
      secondButton: this.language.getText('GUIPasswordResetclose'),
      secondButtonFtn: () => this.setState({showAlertPasswordExpired:false}),
      buttonFun: () =>  this.openWindowToChangePsw()
    });
  }
  setObjTimePreview=()=>{
    let time = getCurrentTimeInSec();
    let previewTime =  time - this.props.preview.initialTimeSec + this.props.preview.totalPreviewTime;
    this.actionPrevRecord({process:1, camId:this.props.preview.camId, callOutId:this.props.preview.callOutId,previewTime,callId:0})
  }

  openWindowToChangePsw = () => {
    this.setState({showAlertPasswordExpired:false});
    this.props.setShowPswResetAlert(true);
  }
  render() {
    return (
      <div className='workSpace' onKeyUp={this.isPressedUp} tabIndex='0'>
        {(this.userState === USER_STATE.CALL_OUT && this.sharedData.getDataPreviewPro().dialingMode === 1 && !this.props.preview.simultaneosRecs)  &&
          <CallOutContainer
            time={this.sharedData.getManualCallTime()}
            phone={this.props.preview.phoneToCall}
            userHangedout={() => this.userHangedout()}
            actionPrevRecord={this.actionPrevRecord} />}
        {this.state.draggableComponentList.map(item =>
          item.component(this.state.propsDraggables[item.idComponent], this.state.zIndexDraggableWindows[item.idComponent], component => this.sendToTop(component))
        )}
        {!this.state.isLogged && <ValidatingTelephonyLocked setIsLogged={this.setIsLogged} />}
        {(this.state.isLogged && this.state.showAlertPasswordExpired) && this.fillAlertPasswordExpiredModal()}
        <BlockingPanel />

        <WorkBar keyPressed={this.state.keyPressed} />
        <WorkBarExpanded windowsOpened={this.state.draggableComponentList} />

        {this.state.hasUnifiedMessage && <UnifiedMessaging />}
        <div className='informationSpace'>
          <AgentState smallSize={false} listenerActions={true} />
          <div className={'connectionBanner ' + (this.state.alertConnection ? 'activeWorkSpace' : '')}>
            <div id='connectionInformation'>
              <img src={warningAlert} alt='' />
              <span>
                {this.onStreamAlert(this.props.stramLevel)}
                {this.messageConnection}
              </span>
            </div>
            <div id='boton'>
              <Button
                color='tertiary'
                onClick={() => { this.closeAlert() }}>
                {this.language.getText('GUIConnectivitybtnClose')}
              </Button>
            </div>
          </div>
          <div className="informationSpaceBottom">
            {this.state.hasUnifiedMessage && <MessageBar />}
            {this.renderCallSpace()}
          </div>
         
        </div>
        {this.state.alert && this.fillAlertModal()}
        <AlertsContainerMessage actionAlert={this.state.actionAlert} alertMessage={this.state.newAlertMessage} />
        <OngoingCallIvrModal />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  const { showAlertModal } = AlertModalActions.creators;
  return {
    consultingApp: () => {
      dispatch(consultingApp());
    },
    noConsultingApp: () => {
      dispatch(noConsultingApp());
    },
    moveBlockingPanel: newZIndex => {
      dispatch(moveBlockingPanel(newZIndex));
    },
    manualCall: data => {
      dispatch(manualCall(data));
    },
    showAlertModal: payload => {
      dispatch(showAlertModal(payload));
    },
    logout: () => {
      dispatch(logout());
    },
    sendMessageAgentReady: () => {
      dispatch(sendMessageAgentReady());
    },
    actionPreviewRecord: (data) => { 
      dispatch(actionPreviewRecord(data)); 
    },
    setIsRunningClock: (data) => { 
      dispatch(setIsRunningClock(data)); 
    },
    saveInitialTime: () => {
      dispatch(saveInitialTime());
    },
    setShowPswResetAlert: (action) => {
      dispatch(setShowPswResetAlert(action));
    },
    removeRecord: (action) =>{
      dispatch(removeRecord(action))
    },
    setAgentList: (data) => {
      dispatch(setAgentList(data))
    }
  };
}

function mapStateToProps(state) {
  return {
    userState: state.userState,
    windowVisible500: state.windowVisible500,
    dragWindowController: state.dragWindowController,
    messagesIntegrations: state.messagesIntegrations,
    showUnifiedMessages: state.unifiedInboxState.show,
	  stramLevel: state.sipClientActions.stream,
    preview: state.preview,
    allowChangeDialing: state.agentPermissions.allowChangeDialing,
    previewSimultaneousRecs: state.preview.simultaneosRecs

  }
}

export default workSpace = connect(mapStateToProps, mapDispatchToProps)(workSpace);



// WEBPACK FOOTER //
// ./src/components/workSpace/workSpace.jsx